import React from "react";
import ProjetoLayout from "../componentes/ProjetoLayout";

function PrevisaoTempo() {
  return (
    <ProjetoLayout
      titulo="Previsão do Tempo"
      tagline="App web moderno e responsivo que apresenta informações climáticas em tempo real consumindo APIs externas."
      liveUrl="https://previsao-do-tempo-front.vercel.app"
      capa="/capa-previsao.png"
      capaAlt="Previsão do Tempo"
      tags={[
        "React",
        "JavaScript",
        "Material-UI",
        "OpenWeatherMap",
        "Geonames",
        "Jest",
        "Testing Library",
      ]}
      meta={[
        { ic: "code", label: "Tipo", value: "Frontend + APIs" },
        { ic: "role", label: "Papel", value: "Desenvolvedor" },
        { ic: "local", label: "Status", value: "No ar" },
      ]}
    >
      <h2>Clima em tempo real</h2>
      <p>
        Aplicação web moderna e responsiva que apresenta informações climáticas
        detalhadas para qualquer cidade. Foi desenvolvida com uma{" "}
        <strong>interface simples e intuitiva</strong> para consulta de dados em
        tempo real, usando dados reais de APIs externas.
      </p>
      <p>
        A aplicação consome a <strong>API do OpenWeatherMap</strong> para
        temperatura, umidade e condições, e a <strong>API do Geonames</strong>{" "}
        para o autocompletar na busca de cidades. Construída em{" "}
        <strong>React</strong> com componentes do <strong>Material-UI</strong> e
        imagens de fundo dinâmicas conforme o clima.
      </p>

      <h3>Principais funcionalidades</h3>
      <ul>
        <li>
          <strong>Busca por cidade:</strong> com autocomplete, exibindo
          temperatura, máxima, mínima, umidade, vento e horários do sol.
        </li>
        <li>
          <strong>Sugestões de cidades:</strong> cards interativos pré-configurados
          (Joinville, Florianópolis, Curitiba) para acesso rápido.
        </li>
        <li>
          <strong>Exibição dinâmica:</strong> ícones que representam visualmente
          cada condição climática.
        </li>
        <li>
          <strong>Testes automatizados:</strong> testes unitários e de integração
          com React Testing Library e Jest, mockando as respostas das APIs.
        </li>
      </ul>
    </ProjetoLayout>
  );
}

export default PrevisaoTempo;
